import {
  useOrganizationModalsContext,
  MODAL_NAMES,
} from '../../contexts/OrganizationModalsContext';
import { NewMemberModal } from '../Modals/NewMemberModal';
import { RevokeAccessModal } from '../Modals/RevokeAccessModal';
import { ResetPasswordModal } from '../Modals/ResetPasswordModal';
import { EditMemberModal } from '../Modals/EditMemberModal';
import { ResetMultifactorModal } from '../Modals/ResetMultifactorModal';
import { BulkRevokeAccessModal } from '../Modals/BulkRevokeAccessModal';

export const Modals = () => {
  const { modalState } = useOrganizationModalsContext();

  return (
    <>
      {modalState?.name === MODAL_NAMES.NEW_MEMBER && <NewMemberModal />}
      {modalState?.name === MODAL_NAMES.UPDATE_MEMBER && <EditMemberModal />}
      {modalState?.name === MODAL_NAMES.RESET_PASSWORD && <ResetPasswordModal />}
      {modalState?.name === MODAL_NAMES.REVOKE_ACCESS && <RevokeAccessModal deselectOnSuccess />}
      {modalState?.name === MODAL_NAMES.BULK_REVOKE_ACCESS && <BulkRevokeAccessModal />}
      {modalState?.name === MODAL_NAMES.RESET_MFA && <ResetMultifactorModal />}
    </>
  );
};
